export default "__VITE_ASSET__63a3e488__"